import { useReducer } from 'react';

import { Commit, User } from 'src/components/types';
import { Participant } from 'src/components/types/src/refs';

export type UpdateCommitAction = {
  type: 'approve' | 'unapprove';
  agent: User;
};

export function useCommitPageReducer(rawCommit: Commit): {
  commit: Commit;
  dispatchCommitUpdate: React.Dispatch<UpdateCommitAction>;
} {
  const reducer = (commit: Commit, action: UpdateCommitAction): Commit => {
    let newCommit;
    switch (action.type) {
      case 'approve': {
        const approver = action.agent;
        if (approver === undefined || approver === null) {
          break;
        }
        const currentDate = new Date();
        const participant = {
          approved: true,
          participated_on: currentDate.toISOString(),
          role: 'PARTICIPANT',
          type: 'participant',
          user: approver,
        } as Participant;
        const participants = [participant].concat(
          commit.participants?.filter(p => p.user.uuid !== approver.uuid) || []
        );
        newCommit = { ...commit, participants };
        break;
      }
      case 'unapprove': {
        const unapprover = action.agent;
        if (unapprover === undefined || unapprover === null) {
          break;
        }
        // remove the unapprover, but add them back in if they were already a participant for reasons other than a previous approval
        const participants = (
          commit.participants?.filter(p => p.user.uuid !== unapprover.uuid) ||
          []
        ).concat(
          rawCommit.participants?.filter(
            p => p.user.uuid === unapprover.uuid && !p.approved
          ) || []
        );
        newCommit = { ...commit, participants };
        break;
      }
      default:
        throw new Error();
    }
    return newCommit || commit;
  };

  const [commit, dispatchCommitUpdate] = useReducer(reducer, rawCommit);

  return {
    commit,
    dispatchCommitUpdate,
  };
}
